import {ActionTree} from "vuex";
import axios from 'axios';
import {TemplateParamsFilter, TemplateParamsState} from "@/store/template_params/types";
import {RootState} from "@/store/types";

export const actions: ActionTree<TemplateParamsState, RootState> = {
    async getTemplateParams({commit}, data: TemplateParamsFilter) {
        try {
            const resp = await axios({
                url: '/lk-api/distribution/template/params',
                params: {
                    transport: data?.transport,
                    name: data?.name,
                    page_number: data?.page_number,
                },
            });
            if (data?.page_number > 1) {
                commit("pushTemplateParams", resp.data);
            } else {
                commit('setTemplateParams', resp.data);
            }
            return resp.data;
        }
        finally {
            commit('setLoading', false);
        }
    }
}